import React, { useState } from 'react';
import { Excalidraw, exportToCanvas, exportToBlob } from "@excalidraw/excalidraw";

const Footer = (props) => {
  let excalidrawRef = props.reference;
  return (
    <div className="footer">
      <button onClick={async () => { window.parent.postMessage({func: 'closeDrawModal', message: ''}, "*"); }} className="cancel-button s">Cancel</button>
      <button className="footer-button"
      onClick={async () => {
        let currentAPI = excalidrawRef.current;
        if (!currentAPI) {
          return
        }
        const elements = currentAPI.getSceneElements();
        if (!elements || !elements.length) {
          return
        }
        const scale = 2;

        const blob = exportToBlob({
          elements,
          appState: {
            exportWithDarkMode: false,
          },
          files: currentAPI.getFiles(),
          mimeType: "image/png",
          quality: 1,
        })

        blob.then((content) => {

          // Convert blob to base64
          const reader = new FileReader();
          reader.onloadend = function () {
            // Once converted to base64, post the message with the base64 string
            const base64string = reader.result;
            console.log(base64string);
            window.parent.postMessage({ from: 'draw', base64string: base64string }, "*");
          };
          reader.readAsDataURL(content); // Read the blob as Data URL

          
        }).catch((error) => {
          console.log(error);
      });

      }}
      >Save</button>
    </div>
  );
};

export default Footer;